<script lang="ts">
    export let text: string
</script>

<div class="text">
    {@html text}
</div>

<style>
    .text {
        text-align: left;
        font-family: "Libre Franklin", sans-serif;
    }
</style>
